import { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '@config/firebase';
import { logError, logInfo } from '@utils/logger';

export const useModals = () => {
  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [showQuickSurvey, setShowQuickSurvey] = useState(false);
  const [showEditSurvey, setShowEditSurvey] = useState(false);
  const [surveyToEdit, setSurveyToEdit] = useState(null);
  const [showHighPoleSurvey, setShowHighPoleSurvey] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showBookSurvey, setShowBookSurvey] = useState(false);

  const handleSurveyUpdate = async (updatedData) => {
    if (!surveyToEdit?.id) {
      throw new Error('Invalid survey data');
    }

    try {
      const surveyRef = doc(db, 'surveys', surveyToEdit.id);
      await updateDoc(surveyRef, {
        ...updatedData,
        updatedAt: new Date().toISOString()
      });
      
      setShowEditSurvey(false);
      setSurveyToEdit(null);
      logInfo('Survey updated successfully');
      return true;
    } catch (error) {
      logError('Failed to update survey:', error);
      throw error;
    }
  };

  return {
    modalStates: {
      showImport,
      showExport,
      showShare,
      showReports,
      showQuickSurvey,
      showEditSurvey,
      surveyToEdit,
      showHighPoleSurvey,
      showFileUpload,
      showBookSurvey
    },
    modalHandlers: {
      setShowImport,
      setShowExport,
      setShowShare,
      setShowReports,
      setShowQuickSurvey,
      setShowEditSurvey,
      setSurveyToEdit,
      setShowHighPoleSurvey,
      setShowFileUpload,
      setShowBookSurvey,
      handleSurveyUpdate
    }
  };
};